import { scenarioVariationUpload } from './../../constants';
import { size } from 'lodash';

const modifyFiles = (existingFiles, files, fileSystem, scenarioListFile, scenarioSDDFile) => {
    let fileToUpload = {};
    for(let i = 0; i < files.length; i++) {
        const id = size(existingFiles) + i + 1;

        fileToUpload = {
            ...fileToUpload,
            [id]: {
                id,
                file: files[i],
                progress: 0,
                fileSystem,
                scenarioListFile,
                scenarioSDDFile,
            },
        }
    }
    return fileToUpload;
}


const INITIAL_STATE = {
    fileProgress: {
    }
}

const fileProgressReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case scenarioVariationUpload().SET_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    ...modifyFiles(state.fileProgress, action.payload, action.fileSystem),
                    // ...modifyFiles(state.fileProgress, action.payload, action.fileSystem,
                    // action.scenarioListFile, action.scenarioSDDFile),
                },
            }

        case scenarioVariationUpload().SET_UPLOAD_PROGRESS:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload.id]: {
                        ...state.fileProgress[action.payload.id],
                        progress: action.payload.progress,
                    },
                },
            }

        case scenarioVariationUpload().SUCCESS_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: 1,
                    },
                },
            }

        case scenarioVariationUpload().FAILURE_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: 0,
                        progress: 0
                    },
                },
            }

        default:
            return state
    }
}

export default fileProgressReducer;